































import { defineComponent, PropType } from '@vue/composition-api';
import { TranslateResult } from 'vue-i18n';

export default defineComponent({
  props: {
    isCanRetry: {
      type: Boolean,
      default: false,
    },
    retryBtnText: {
      type: String as PropType<string | TranslateResult>,
      default: '',
    },
    fixBtnText: {
      type: String as PropType<string | TranslateResult>,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    // 用于埋点用
    level: {
      type: String,
      default: '',
    },
  },
});
